import { HTTP, HTTP_CONFIG } from '../../common/http';

import { SET_ORIGINAL_QUOTE, SET_ORIGINAL_DONATION } from './mutation-types';

export function setOriginalQuote({ commit, state }, originalQuote) {
    commit(SET_ORIGINAL_QUOTE, originalQuote);
}

export function setOriginalDonation({ commit, state }, donation) {
    commit(SET_ORIGINAL_DONATION, donation);
}
